var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.414 39L37 50.586 54.586 33 51 29.414 37.707 42.707a.999.999 0 01-1.414 0L29 35.414 25.414 39zM37 53a.997.997 0 01-.707-.293l-13-13a.999.999 0 010-1.414l5-5a.999.999 0 011.414 0L37 40.586l13.293-13.293a.999.999 0 011.414 0l5 5a.999.999 0 010 1.414l-19 19A.997.997 0 0137 53z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M39 66h2v-2h-2zM39 16h2v-2h-2zM14 41h2v-2h-2zM64 41h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 10c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 62C22.355 72 8 57.645 8 40S22.355 8 40 8s32 14.355 32 32-14.355 32-32 32z",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationSuccess;